import axios from "axios";

const BASE_URL = process.env.REACT_APP_BASE_URL + "/customer";

const setTokenAllHeaders = async () => {
  const token = localStorage.getItem("adminToken");
  axios.defaults.headers.common["Authorization"] = token;
};

const getAllCustomers = async ({ limit = 10, page = 0, status = null, sortModel = [], filterModel = [] }) => {
  try {
    await setTokenAllHeaders();
    let sendStatus = status;
    if (sendStatus === 0) {
      sendStatus = null;
    }
    let search = null;
    if (filterModel['quickFilterValues']) {
      search = filterModel['quickFilterValues'][0] || null;
    }
    const response = await axios.get(`${BASE_URL}/get`, {
      params: {
        limit,
        page,
        sendStatus,
        search,
        sort: sortModel,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching customer:", error);
    throw error;
  }
};
const getCustomerDetails = async ({ customerId }) => {
  try {
    await setTokenAllHeaders();

    const response = await axios.get(`${BASE_URL}/detail?customerId=${customerId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching customer details:", error);
    throw error;
  }
};

const updateCustomerStatus = async (params) => {
  try {
    await setTokenAllHeaders();
    const dt = { ...params };
    const response = await axios.post(`${BASE_URL}/status/`, dt);
    return response.data;
  } catch (error) {
    console.error(`Error updating customer status:`, error);
    throw error;
  }
};
const getCustomerLoginToKen = async (params) => {
  try {
    await setTokenAllHeaders();
    const dt = { ...params };
    const response = await axios.post(`${BASE_URL}/login`, dt);
    return response.data;
  } catch (error) {
    console.error(`Error getting customer login token status:`, error);
    throw error;
  }
};


const getCustomerAddresses = async (customerId) => {
  try {
    await setTokenAllHeaders();
    const response = await axios.get(`${BASE_URL}/${customerId}/addresses`);
    return response.data;
  } catch (error) {
    console.error("Error fetching customer addresses:", error);
    throw error;
  }
};

const getCustomerAddressLocation = async (addressId) => {
  try {
    await setTokenAllHeaders();
    const response = await axios.get(`${BASE_URL}/address/${addressId}/location`);
    return response.data;
  } catch (error) {
    console.error("Error fetching customer address location:", error);
    throw error;
  }
};

const getOutOfZoneAddresses = async ({
  limit = 15,
  page = 0,
  search = null,
  sort = [],
}) => {
  const response = await axios.get(
    `${BASE_URL}/addresses/out-of-zone`,
    {
      headers: {
        // Keep your existing Authorization header here.
        Authorization:
          localStorage.getItem("adminToken"),
      },

      params: {
        limit,
        page,
        search,
        sort: JSON.stringify(sort || []),
      },

      // Allow this report up to 3 minutes.
      timeout: 180000,
    }
  );

  return response.data;
};

const revokeSessions = async (customerId) => {
  await setTokenAllHeaders();
  return (await axios.post(`${BASE_URL}/${customerId}/sessions/revoke`, {})).data;
};
const customerApi = {
  revokeSessions,
  getAllCustomers,
  updateCustomerStatus,
  getCustomerLoginToKen,
  getCustomerDetails,
  getCustomerAddresses,
  getCustomerAddressLocation,
  getOutOfZoneAddresses
};

export default customerApi;
